import { TranslateService } from '@ngx-translate/core';
import { compact, trim } from 'lodash';
import { compactSpaces } from '../../../../utils/helpers/string.helper';
import { Item } from '../../../item-data/item.model';
import { MoneyPipe } from '../../../shared/pipes/money/money.pipe';

// const shave = require('../../../shared/vendor/shave');

export const itemTmpl = (
  moneyPipe: MoneyPipe,
  translateService: TranslateService,
  newItemFieldKey: string,
  locationPath: string,
  showProductCode: boolean,
  separatePartsAndLabor: boolean,
  productNameEnabled: boolean,
  liDom: any,
  item: Item
) => {
  let contents: string;

  if (item.id) {
    const header =
      showProductCode && item.code
        ? compact([item.code, item.name]).join(' - ')
        : item.name || '';
    const itemRate = moneyPipe.transform(
      item.rate,
      item.currencyCode,
      item.locale
    ) as string;
    const itemUnitType: string = separatePartsAndLabor
      ? translateService.instant(item.isPart() ? 'LABEL.PARTS' : 'LABEL.LABOR')
      : '';
    const itemMeta = compact([
      itemRate,
      itemUnitType,
      productNameEnabled ? item.details : '',
    ]).join(' - ');

    contents = `
      <strong class="header">
        ${header}
      </strong>
      
      <div class="item-meta">
        ${itemMeta}          
      </div>`;
  } else {
    contents = `
      <div class="new-item-wrapper">
        <span class="new-item-icon">
          <svg>
            <use xlink:href="${locationPath}#add-new-item-icon"></use>
          </svg>
        </span>
        
        <div class="new-item-contents">
          <strong class="new-item-field">
            ${item.getFieldInContent(newItemFieldKey, '')}
          </strong>
          
          <span class="new-item-label">
            ${translateService.instant('LABEL.NEW_ITEM')}
          </span>
        </div>
      </div>`;
  }

  liDom.innerHTML = compactSpaces(trim(contents));

  // setTimeout(() => {
  //   const el = liDom.getElementsByClassName(descriptionTextClass)[ 0 ];
  //
  //   if (el) {
  //     const computedStyles = windowRef.getComputedStyle(el),
  //           lineHeight     = parseInt(computedStyles.getPropertyValue('line-height'), 10),
  //           maxHeight      = lineHeight * 2.5;
  //
  //     if (maxHeight) {
  //       shave(el, maxHeight);
  //     }
  //   }
  // });
};

export const categoryTmpl = (
  categoryLabel: string,
  chooseMultipleLabel: string,
  chooseMultipleCallback: (evt: Event) => void,
  categoryDom: any
) => {
  const contents: string = `
    <div class="action-header">
      <button type="button"
              class="choose-multiple-action">
        ${chooseMultipleLabel}
      </button>
      
      <hr class="category-divider" />
    </div>`;

  let chooseMultipleEl = categoryDom.querySelector('.choose-multiple-action');

  if (chooseMultipleEl) {
    chooseMultipleEl.removeEventListener(
      'click',
      chooseMultipleCallback,
      false
    );
  }

  categoryDom.innerHTML = compactSpaces(trim(contents));

  chooseMultipleEl = categoryDom.querySelector('.choose-multiple-action');

  chooseMultipleEl.addEventListener('click', chooseMultipleCallback, false);
};
